export default "__VITE_ASSET__1a68ad9d__"